import { memo, useEffect } from "react"
import { useSearchParams } from "react-router-dom";
import { ADMIN_URL } from "~/config/config";
import { useAtom } from 'jotai';
import { userACRoles, userInformationAtom } from "~/stores/UserStore";
import { ACLTLGeoAPIs } from "~/common/typescript/apis/ACLTLGeoAPIs";

const ACLTLGeoController = () => {
  const [loggedUser, setLoggedUserStore] = useAtom(userInformationAtom);
  const [roles, setRoles] = useAtom(userACRoles);
  useEffect(() => {
    if (loggedUser) {
      ACLTLGeoAPIs.remote_ACLTLGeo_getMyRoles().then((response) => {
        let roles = response;
        setRoles(roles);
      })
    }
  }, [loggedUser])

  return <></>
}

export default memo(ACLTLGeoController);